/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type YourWorkRedirectPageEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const yourWorkRedirectPageEntryPoint: EntryPoint<
	YourWorkRedirectPageEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<YourWorkRedirectPageEntryPointComponent>(
		/* webpackChunkName: "async-your-work-redirect-page-entrypoint" */ './YourWorkRedirectPage.tsx',
	),
	getPreloadProps: () => ({
		queries: {},
		extraProps: {},
	}),
});
